import { TaxonomicProfileDTO } from './TaxonomicProfileDTO'
import { TaxonomicProfile } from './TaxonomicProfileModel'

export const mapTaxaProfileDtoToTaxaProfileModel = (taxaProfileDTO: TaxonomicProfileDTO): TaxonomicProfile => {
    return taxaProfileDTO as TaxonomicProfile
}
